import { Injectable } from '@angular/core';
import { GaoDeLocation,PositionOptions } from '@ionic-native/gao-de-location/ngx';
import { CommonService } from '../service/common.service';
import {WxjssdkService} from 'src/service/wxjssdk.service';
declare var app;
declare var AMap;
@Injectable({
  providedIn: 'root'
})
export class MapclientServiceService {
  map: any;//地图对象
  marker: any;//标注样式
  geolocation: any;//定位功能
  geocoder: any;
  circle:any;//范围配置
  m1:any;
  m2:any;
  constructor(
    private gd: GaoDeLocation,
    private com:CommonService,
    private weixin:WxjssdkService
    ) { }
/**
 * 定位功能-获取当前位置
 * @param element 
 */
  Geolocation(element:any):Promise<any>{
    const that=this;
    return new Promise<any>((reject,reason)=>{
      //debugger;
      // that.geolocations.getCurrentPosition({enableHighAccuracy:true}).then((current)=>{
      //     let longitude=current.coords.longitude;
      //     let latitude = current.coords.latitude;
      //     that.map=new AMap.Map(element, {
      //       resizeEnable: true
      //      });
      //     let geocoder,marker;
      //     geocoder = new AMap.geocoder({
      //       enableHighAccuracy: true,//是否使用高精度定位，默认:true
      //           timeout: 10000,          //超过10秒后停止定位，默认：无穷大
      //           maximumAge: 0,           //定位结果缓存0毫秒，默认：0
      //           convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
      //           showButton: true,        //显示定位按钮，默认：true
      //           buttonPosition: 'RB',    //定位按钮停靠位置，默认：'LB'，左下角
      //           buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
      //           showMarker: true,        //定位成功后在定位到的位置显示点标记，默认：true
      //           showCircle: true,        //定位成功后用圆圈表示定位精度范围，默认：true
      //           panToLocation: true,     //定位成功后将定位到的位置作为地图中心点，默认：true
      //           zoomToAccuracy:true      //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
      //     });
      //     marker=new AMap.Marker();
      //     that.map.add(marker);
      //     let lnglat=longitude+","+latitude;

      //   marker.setPosition(lnglat);
      //   geocoder.getAddress(lnglat,function(status,result){
      //     if(status==='complete'&& result.regeocode){
      //       console.log(result.regeocode.formattedAddress);
      //     }else{
      //       console.log(result);
      //     }
      //   });

      // }).catch(error=>{

      // });
      if(that.com.IsWeixinBrowser){
            try{
               that.map=new AMap.Map(element, {
                    resizeEnable: true,
                    zoom:11
                  });
                  AMap.plugin('AMap.Geolocation',function(){
                    that.geolocation = new AMap.Geolocation({
                      enableHighAccuracy: true,//是否使用高精度定位，默认:true
                      timeout: 10000,          //超过10秒后停止定位，默认：无穷大
                      maximumAge: 0,           //定位结果缓存0毫秒，默认：0
                      convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
                      showButton: true,        //显示定位按钮，默认：true
                      buttonPosition: 'RB',    //定位按钮停靠位置，默认：'LB'，左下角
                      buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                      showMarker: true,        //定位成功后在定位到的位置显示点标记，默认：true
                      showCircle: true,        //定位成功后用圆圈表示定位精度范围，默认：true
                      panToLocation: false,     //定位成功后将定位到的位置作为地图中心点，默认：true
                      zoomToAccuracy:false      //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                  });
                  that.map.addControl(that.geolocation);
                  that.geolocation.getCurrentPosition();
                  AMap.event.addListener(that.geolocation, 'complete', (status, result)=>{
                    //debugger;
                    // that.map && that.map.destroy();
                    console.log(status,"定位返回Status");
                    console.log(result,"定位返回结果");
                    if(status.accuracy==440){
                      reason(status);
                    }else{
                      status["map"]=that.map;
                      reject(status);
                    }
                  });
                  AMap.event.addListener(that.geolocation, 'error', (status, result)=>{
                    console.log(status,"定位返回addListener");
                    console.log(result,"定位返回结果addListener");
                    // that.map && that.map.destroy();
                    reason(status);
                  });
                  });
              }catch(error){
                console.log(error,"定位catch");
                reason(error);
              }
      }else{
        try{
        that.map=new AMap.Map(element, {
          resizeEnable: true,
          zoom:11
         });
         AMap.plugin('AMap.Geolocation',function(){
          that.geolocation = new AMap.Geolocation({
            enableHighAccuracy: true,//是否使用高精度定位，默认:true
            timeout: 10000,          //超过10秒后停止定位，默认：无穷大
            maximumAge: 0,           //定位结果缓存0毫秒，默认：0
            convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
            showButton: true,        //显示定位按钮，默认：true
            buttonPosition: 'RB',    //定位按钮停靠位置，默认：'LB'，左下角
            buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
            showMarker: true,        //定位成功后在定位到的位置显示点标记，默认：true
            showCircle: true,        //定位成功后用圆圈表示定位精度范围，默认：true
            panToLocation: false,     //定位成功后将定位到的位置作为地图中心点，默认：true
            zoomToAccuracy:false      //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        });
        that.map.addControl(that.geolocation);
        that.geolocation.getCurrentPosition();
        AMap.event.addListener(that.geolocation, 'complete', (status, result)=>{
          // that.map && that.map.destroy();
          if(status.accuracy==440){
            reason(status);
          }else{
            status["map"]=that.map;
             reject(status);
          }
        });
        AMap.event.addListener(that.geolocation, 'error', (status, result)=>{
          // that.map && that.map.destroy();
          reason(status);
         
        });
        });
       }catch(error){
        reason(error);
       }
      }
  
    });
  }
  /**
   * Cordovad定位，只限于Android
   */
  // getCurrentPosition():Promise<any>{
  //   return new Promise<any>((resolve,reject)=>{
  //     cordova.plugins.camera.getCurrentPosition("获取当前定位",function(data){
  //       if(data){
  //         if(data.errcode){//表示定位失败
  //           reject(data);
  //         }else{
  //           resolve(data);
  //         }
  //       }else{
  //         reject(data);
  //       }
  //   },function(data){
  //        reject(data);
  //   })
  //   });
  // }
  /**
   * 高德地图定位返回坐标以及位置，支持android,ios
   */
  getGDCurrentPosition():Promise<PositionOptions>{
    const that=this;
    return  new Promise<PositionOptions>((resolve,reject)=>{
      let resipn:any={};
      that.gd.getCurrentPosition().then((pt:PositionOptions)=>{
        // if(pt.status=="定位成功"){
        //   resolve(pt);
        // }else{
        //   reject(pt);
        // }
        console.log(pt,"定位成功");
        resolve(pt);
      }).catch(err=>{
        console.log(err,"定位失败");
        reject(err);
      });
    });
  }
   /**
   * 高德地图根据门店地址获取坐标
   */
  // getGDAddressPosition(element:any,address):Promise<any>{
  //   const that=this;
  //   return  new Promise<any>((resolve,reject)=>{
  //     that.map = new AMap.Map(element, {
  //       resizeEnable: true
  //   });
  //   var geocoder = new AMap.Geocoder({
  //     city: "全国", //城市设为北京，默认：“全国”
  //    });
  //    geocoder.getLocation(address,function(status,result){
  //     if (status === 'complete'&&result.geocodes.length) {
  //       var lnglat = result.geocodes[0];
  //       resolve(lnglat);
  //     }else{
  //       reject("定位失败");
  //     }
  //    });
  //   });
  // }
  getGDAddressPosition(element:any,address):Promise<any>{
    const that=this;
    return  new Promise<any>((resolve,reject)=>{
      AMap.plugin('AMap.Autocomplete', function () {
        // 实例化Autocomplete
        var autoOptions = {
            city: '全国'
        }
        console.log("定位失败");
        var autoComplete = new AMap.Autocomplete(autoOptions);
        autoComplete.search(address, function (status, result) {
            // 搜索成功时，result即是对应的匹配数据
            if (status === 'complete' && result.count > 0){
              console.log(result,"显示");
              let lnglat="";
              // //debugger;
             for(var i = 0; i<result.tips.length;i++){
               if( result.tips[i].location.lng && result.tips[i].location.lat ){
                 if(!lnglat){
                  lnglat = result.tips[i].location;
                 }
               }
             }
             resolve(lnglat);
            }else{
              reject("定位失败");
            }
           
        });
      });
    });
  }
  /**
   * 获取两点之间的距离
   * @param stordpostion 门店坐标
   * @param nowpostion 当前坐标
   */
  getMapdetail(element:any,stordpostion,nowpostion) :Promise<any>{

    let that =this;
    return  new Promise<any>((resolve,reject)=>{
       // let stored= stordpostion.split(",")
    console.log(stordpostion,"门店坐标");
    console.log(nowpostion,"当前坐标");
      that.map = new AMap.Map(element, {
        resizeEnable: true,
        city: '全国',
        panToLocation: true,     //定位成功后将定位到的位置作为地图中心点，默认：true
        zoomToAccuracy: true,     //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        zoom: 13,
        center:[stordpostion[0], stordpostion[1]]
       });
       that.m1 = new AMap.Marker({
        map:  that.map,
        draggable:true,
        position: new AMap.LngLat(stordpostion[0], stordpostion[1])
    });
    that.m2 = new AMap.Marker({
        map:  that.map,
        draggable:true,
        position:new AMap.LngLat(nowpostion[0], nowpostion[1])
    });
    that.map.setFitView();
   
    that.computeDis();
    });

   
    // position = postion[0] + "," + postion[1];
    // position2= postion2[0] + "," + postion2[1];
  }
   computeDis(){
     console.log("212");
    let line,text,that= this;
      var p1 = that.m1.getPosition();
      var p2 = that.m2.getPosition();
      var textPos = p1.divideBy(2).add(p2.divideBy(2));
      var distance = Math.round(p1.distance(p2));
      console.log(distance,"距离");
      var path = [p1,p2];
      if(!line){
          line = new AMap.Polyline({
             map:that.map,
              strokeColor:'#80d8ff',
              isOutline:true,
              outlineColor:'white',
              path:path
          });
      }else{
          line.setPath(path);
      }
      if(!text){
          text = new AMap.Text({
              text:'两点相距'+distance+'米',
              position: textPos,
              map:that.map,
              style:{'background-color':'#29b6f6',
              'border-color':'#e1f5fe',
              'font-size':'12px'}
          })
      }else{
          text.setText('两点相距'+distance+'米')
          text.setPosition(textPos)
      }
  }

/**
 * 根据坐标渲染地图
 * @param lng 
 * @param lat 
 */
  mapDrtail(elemnet:any,lng,lat){
    const that = this;
    console.log(lng,lat);
        var mapop = {
          city:"全国",
          zoom: 16,
          center:[lng,lat],
          resizeEnable: true,
          panToLocation: false,     //定位成功后将定位到的位置作为地图中心点，默认：true
          zoomToAccuracy: false,     //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
      };

      that.map = new AMap.Map(elemnet, mapop);
      AMap.plugin('AMap.Geolocation',function(){
      var geocoder= new AMap.Geolocation({
      });
      that.marker = new AMap.Marker({
        position: new AMap.LngLat(lng, lat)
        });
        that.map.add(that.marker);
        var lnglat = [lng, lat];
        that.marker.setPosition(lnglat);
        // geocoder.getAddress(lnglat, function (status, result) {
        // });
      });
         
            // var geocoder = new AMap.Geocoder({
            //     city: "全国", 
            //   });
         
  }
/**
 * 高德地图签到功能
 * @param element dom对象
 */
getMaplocation(element:any):Promise<any>{
  const that=this;
  return new Promise<any>((reject,reason)=>{
    that.Geolocation(element).then((data)=>{
      // console.log(data);
      if(data.accuracy==440){
        reason(data);
      }else{
        let dataMessage=that.onComplete(data);
        reject(dataMessage);
      }
    },(error)=>{
      reason(error);
    });
  });
}

onComplete(data) {
  const that=this;
   if(app.CIRCLE){//启用范围
    that.circle=that.dracircle(data.position.lng,data.position.lat);
    that.map.add(that.circle);
     }
    that.map.setFitView();
  return data;
  }
  //解析定位错误信息
  onError(data) {
    alert(data.message);
    return data.message;
  }
    /**
   * 范围配置
   * @param lng 横坐标
   * @param lat 纵坐标
   */
  dracircle(lng:string='116.405467',lat:string='39.907761'){
    let lnglatXY = new AMap.LngLat(lng,lat);
    return new AMap.Circle({
      center: lnglatXY, // 圆心位置
      radius: app.RADIUS,  //半径
      strokeColor: "#FFFFFF",  //线颜色
      strokeOpacity: 1,  //线透明度
      strokeWeight: 0,  //线粗细度
      fillColor: "#63B8FF",  //填充颜色
      fillOpacity: 0.35 //填充透明度
    });
  }
  /**
   * 描点标注
   * @param position 坐标
   */
  drawMarker(lng:any='116.405467',lat:any='39.907761',message:string=null) {
    let lnglatXY = new AMap.LngLat(lng,lat);
   return new AMap.Marker({
      position: lnglatXY,
      icon: new AMap.Icon( {
        // size: new AMap.Size( 30, 30 ),  //图标大小
        image: "../../../assets/img/mark_b.png",
        // imageSize: new AMap.Size( 30, 30 )
      }),
      label:{
        offset: new AMap.Pixel(-1, -20),
       content: "<div class='info'>"+message+"</div>"
    }
    });
  }
 /**
  * 步行导航路线
  * @param element dom对象
  * @param endCoordinate 到达坐标系
  */
  WalkingOptionLine(element:any,endCoordinate:any,):Promise<any>{
    const that=this;
    return new Promise<any>((reject,reason)=>{
      that.Geolocation(element).then((data)=>{
        // console.log(data);
        that.map = new AMap.Map(element, {
          zoom: 14,
          resizeEnable: true
      });
        let walking = new AMap.Walking({});
         //根据起终点坐标规划步行路线
          walking.search([data.position.lng, data.position.lat], [121.484145,31.245521], function(status, result) {
              // result即是对应的步行路线数据信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_WalkingResult
              if (status === 'complete') {
                  if (result.routes && result.routes.length) {
                    that.drawRoute(result.routes[0],that.map);
                      console.log('绘制步行路线完成')
                  }
              } else {
                console.log('步行路线数据查询失败' + result)
              } 
          });
        reject(data);
      },(error)=>{
        reason(error.message);
      });
    });
  }
  //展示图标以及文字
  drawRoute(route,map){
    const that=this;
    let path = that.parseRouteToPath(route);
    let startMarker = new AMap.Marker({
        position: path[0],
        icon: 'https://webapi.amap.com/theme/v1.3/markers/n/start.png',
        map: map,
        label:{
          offset: new AMap.Pixel(-1, -20),
         content: "上海科技京城"
      }
    });
    let endMarker = new AMap.Marker({
        position: path[path.length - 1],
        icon: 'https://webapi.amap.com/theme/v1.3/markers/n/end.png',
        map: map,
        label:{
          offset: new AMap.Pixel(-1, -20),
         content: "门店1101"
      }
    })

    let routeLine = new AMap.Polyline({
        path: path,
        isOutline: true,
        outlineColor: '#ffeeee',
        borderWeight: 2,
        strokeWeight: 5,
        strokeColor: '#0091ff',
        lineJoin: 'round'
    })

    routeLine.setMap(map);

    // 调整视野达到最佳显示区域
    map.setFitView([ startMarker, endMarker, routeLine]);
  }
   // 解析WalkRoute对象，构造成AMap.Polyline的path参数需要的格式
    // WalkRoute对象的结构文档 https://lbs.amap.com/api/javascript-api/reference/route-search#m_WalkRoute
  parseRouteToPath(route) {
    var path = []

    for (var i = 0, l = route.steps.length; i < l; i++) {
        var step = route.steps[i]

        for (var j = 0, n = step.path.length; j < n; j++) {
          path.push(step.path[j])
        }
    }

    return path
}

     
}
